export default __webpack_public_path__ + "static/media/grr.4244c7d4.gif";